<div class="full-modal">
  <img
    class="full-modal__close-button"
    alt="Cerrar"
    src="images/icons/atm-cta-close.svg"
    (click)="handleClose()"
    *ngIf="hideActionButtons"
  />
  <div class="full-modal__container">
    <div class="full-modal__title" *ngIf="title">
      {{ title }}
    </div>
    <div class="full-modal__subtitle" *ngIf="subtitle">
      {{ subtitle }}
    </div>
    <div class="full-modal__description" *ngIf="description">
      {{ description }}
    </div>

    <div class="full-modal__actions" *ngIf="!hideActionButtons">
      <div class="full-modal__confirmation-button">
        <button
          type="button"
          (click)="handleConfirm()"
          class="button button--small button--dark"
        >
          {{ confirmationButtonText }}
        </button>
      </div>
      <div (click)="handleClose()" class="full-modal__cancel-button">
        {{ cancelButtonText }}
      </div>
    </div>
    <ng-content></ng-content>
  </div>
</div>
